<div class="content-container">
    <div class="title d-inline-flex w-100">
        <mwp-text-translate text="PROFILE INFO" jsonKey="profileInfo" />
    </div>
    <div class="content pe-0">
        <div class="d-flex flex-wrap">
            @for (field of profileFields; track field.jsonKey) {
            @if (field.visible) {
            <div class="w-20 pb-3 pe-3">
                <div class="label-alt">
                    <mwp-text-translate [text]="field.label" [jsonKey]="field.jsonKey" />
                </div>

                <div>{{ field.value }}</div>
            </div>
            }
            }
        </div>

        @if (displayEditProfileButton) {
        <div class="footer">
            <div class="w-100 d-flex justify-content-end">
                <button class="mwp-button" (click)="goToProfile()">
                    <mwp-text-translate text="Edit Profile" jsonKey="editProfile" />
                </button>
            </div>
        </div>
        }
    </div>